import { REVOKE_ACCESS } from "./types";

const revokeAccess = () => ({
  type: REVOKE_ACCESS,
});

export default revokeAccess;
